// extracted by mini-css-extract-plugin
export default {"root":"styles_root__No03K","formUser":"styles_formUser__L9dFL"};